// @flow

import type { ProvidersReportState } from "./types";

export const initialState: ProvidersReportState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  coverage: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  coverageChart: null,
};

export default initialState;
